<div class="table-header">
  <div class="license-heading-row">
    <div class="license-title-group">
      <h1 class="license-title">
        Licenses
        <span
          *ngIf="canManageLicenses"
          class="license-info-badge"
          [matTooltip]="
            'To manage licenses, go to License Batches in the left nav.'
          "
          matTooltipShowDelay="150"
          aria-label="License management info"
        >
          !
        </span>
      </h1>
      <div class="line-part"></div>
    </div>
    <span
      class="manage-license-tooltip-target"
      [matTooltip]="manageLicensesTooltip"
      [matTooltipDisabled]="canManageLicenses"
      matTooltipShowDelay="150"
    >
      <button
        class="manage-license-button"
        type="button"
        data-testid="device-license-manage"
        [disabled]="!canManageLicenses"
        (click)="manageLicenses()"
      >
        Manage
      </button>
    </span>
  </div>
</div>

<div class="device-license-toolbar">
  <div class="device-license-result-count">
    {{ linkedLicenseBatches.length }} linked license{{
      linkedLicenseBatches.length === 1 ? '' : 's'
    }}
  </div>
</div>

<div class="device-license-status-card" *ngIf="loading">
  Loading linked licenses...
</div>

<div class="device-license-status-card" *ngIf="!loading && errorMessage">
  {{ errorMessage }}
</div>

<ng-container
  *ngIf="
    !loading && !errorMessage && linkedLicenseBatches.length > 0;
    else noLinkedLicenses
  "
>
  <div class="device-license-list">
    <article
      class="device-license-card"
      *ngFor="let batch of linkedLicenseBatches"
      data-testid="device-license-card"
    >
      <div class="device-license-card-head">
        <div class="device-license-title-block">
          <a
            *ngIf="batch.id && canManageLicenses; else licenseNameFallback"
            class="device-license-name-link"
            [routerLink]="['/licenses/batches', batch.id]"
            [matTooltip]="'Open license batch details'"
            matTooltipShowDelay="150"
          >
            {{ batch.name || 'License Batch' }}
          </a>
          <ng-template #licenseNameFallback>
            <h3>{{ batch.name || 'License Batch' }}</h3>
          </ng-template>
          <span class="device-license-id" *ngIf="batch.id">
            ID: {{ batch.id }}
          </span>
        </div>
      </div>

      <p class="device-license-description">
        <span
          class="device-license-description-text"
          [matTooltip]="batch.description || 'No description provided.'"
          matTooltipShowDelay="200"
        >
          {{ batch.description || 'No description provided.' }}
        </span>
      </p>

      <div class="device-license-chip-list">
        <span class="device-license-chip">
          <span class="device-license-chip-label">Product:</span>
          <span>{{
            batch.product?.name || batch.licensedProductId || 'Not assigned'
          }}</span>
        </span>
        <span class="device-license-chip">
          <span class="device-license-chip-label">Scope:</span>
          <span>{{ batch.scope.name || 'Not assigned' }}</span>
        </span>
        <span class="device-license-chip" *ngIf="batch.optionalValidAfter">
          <span class="device-license-chip-label">Valid from:</span>
          <span>{{ batch.optionalValidAfter | date: 'mediumDate' }}</span>
        </span>
        <span class="device-license-chip" *ngIf="batch.optionalValidBefore">
          <span class="device-license-chip-label">Valid to:</span>
          <span>{{ batch.optionalValidBefore | date: 'mediumDate' }}</span>
        </span>
      </div>
    </article>
  </div>
</ng-container>

<ng-template #noLinkedLicenses>
  <div class="device-license-status-card" *ngIf="!loading && !errorMessage">
    No linked licenses for this device.
  </div>
</ng-template>

<app-device-software-overrides-summary
  [softwareSelectionResolutions]="softwareSelectionResolutions"
  [supportedComponentIds]="supportedComponentIds"
></app-device-software-overrides-summary>
